import { Button } from 'components/Button/Button';
import OtpInput from 'components/OtpInput/OtpInput';
import useAppLanguage from 'hooks/useAppLanguage';
import usePageConfig from 'hooks/usePageConfig';
import messages from './messages';

const AskForTwoFactor = ({
  onTwoFactorChanged,
  isTwoFactorCodeValid,
  checkTwoFactor,
}: {
  onTwoFactorChanged?: (otp: string) => void;
  isTwoFactorCodeValid?: boolean;
  checkTwoFactor?: () => void;
}) => {
  const language = useAppLanguage();
  const pageConfig = usePageConfig();

  const askForTwoFactorMessages = messages[language].askForTwoFactor;

  return (
    <>
      <h1 className="font-semibold leading-9 pl-11 pr-11 text-2.5x1 text-center">
        {askForTwoFactorMessages.heading}
      </h1>
      <p className="leading-9 pl-11 pr-11 pt-2 text-2x1 text-body-text text-center">
        {askForTwoFactorMessages.subHeading}
      </p>
      <div className="bg-background overflow-hidden pb-4 pt-5 px-4 rounded-lg shadow-xl transition-all my-3 mt-6">
        <div className="mt-3 mb-6 sm:mx-auto sm:w-full text-center">
          <p className="font-semibold mb-3 text-header-text">
            {askForTwoFactorMessages.verificationCodeHeading}
          </p>
          <OtpInput
            isNumberInput
            length={6}
            inputClassName="bg-input-background text-input-text"
            onChangeOtp={(otp: string) => {
              if (onTwoFactorChanged) onTwoFactorChanged(otp);
            }}
            warning={isTwoFactorCodeValid === false}
            warningMessage={askForTwoFactorMessages.twoFactorErrorMessage}
          />
        </div>
        <p className="px-3 py-5 flex flex-col text-white">
          {askForTwoFactorMessages.havingTroubleHeading}
        </p>
        <p className="px-3 text-body-text">
          {askForTwoFactorMessages.havingTroubleMessagePart1}
          <a
            href={`mailto:${pageConfig?.app?.supportEmail}`}
            className="text-white">
            {pageConfig?.app?.supportEmail}
          </a>
          {askForTwoFactorMessages.havingTroubleMessagePart2}
        </p>
      </div>
      <Button
        type="button"
        onClick={checkTwoFactor}
        full
        continue
        className="w-full">
        {askForTwoFactorMessages.continueButton}
      </Button>
    </>
  );
};

export default AskForTwoFactor;
